/* ================================= LAZY OR GRADUAL IMAGE LOAD ====================== */

function remove_post_images_spinner_onload(el){
	if(!el.parentNode) return;
	if(el.parentNode.className.indexOf(' loaded') === -1){
		el.parentNode.className += " loaded";
	}
}
function on_image_load(it,a){
	it.style.opacity = 1;
	if(typeof callback === "function")callback(it);
}


window.lazy_load = function(){

	var loaders = document.querySelectorAll('.lazy_load');

	[].forEach.call( loaders, function( a ){

		if ( a.className.indexOf('is-scrolled-to') !== -1 ) return ;

		if ( lib.isScrolledIntoView( a ) ) {

			var noscript = a.parentNode.querySelector('noscript');

			a.classList.add('is-scrolled-to');
			
			if ( ! noscript ) return;

			requestAnimationFrame(()=>{
				var img = document.createElement('img');
				if ( a.hasAttribute('data-srcmobile') ){
					img.src = lib.viewport().width > mobile ? a.href : a.getAttribute('data-srcmobile');
				} else {
					img.src = a.href;
				}
				img.alt = a.getAttribute('data-alt');
				if(a.dataset.srcmobile) img.dataset.srcmobile = a.dataset.srcmobile;
				img.dataset.srcdesktop = a.href;
				img.classList.add('img-byjs');
				noscript.parentNode.replaceChild(img,noscript);
			});

		}
		
	});
	
}

lazy_load();
window.addEventListener('load',lazy_load);
window.addEventListener('scroll',lazy_load);
window.addEventListener('resize',lazy_load);

( function( $ ) {

	$items = $('.lazy_load');
	
	if ( ! $items.length ) return;
	function lazy_load_on_resize(){
		
		$items.each(function(){

			var $srcs = $(this).parent().find('.img-byjs');

			$srcs.each(function(){
				
				requestAnimationFrame(()=>{

					if ( ! this.dataset.srcmobile || ! this.hasAttribute('data-srcmobile' ) ) return;
					
					if ( lib.viewport().width <= mobile ) {
						src = this.dataset.srcmobile;
					} 
					if ( lib.viewport().width > mobile ) {
						src = this.dataset.srcdesktop;
					}
					this.src = src;
				});

			});

		});
	}

	lazy_load_on_resize();
	window.addEventListener('resize', lazy_load_on_resize);
	window.addEventListener('scroll', lazy_load_on_resize);

})(window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/lazyload.js